// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dsok","left":"styles_left__2sVAl","desktopActions":"styles_desktopActions__333ft","title":"styles_title__zuleA"};